// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__-T_a9","form":"styles_form__-G_0u","formTitle":"styles_formTitle__2oTnb","formButtons":"styles_formButtons__FBiAY"};